export const WedSideTemplatePages = (() => {
  /** 官網版面-1 */
  const TemplatePagesArr1: any = [];

  /** 官網版面-2 */
  const TemplatePagesArr2: any = [];

  /** 官網版面-3 */
  const TemplatePagesArr3 = [
    { path: "", name: "Auth", pathName: "Auth", value: "Y", children: [] },
    // LIFF 綁定與處理頁
    { path: "", name: "結帳", pathName: "Checkout", value: "Y", children: [] },
    { path: "", name: "訂單完成", pathName: "CheckoutSecond", value: "Y", children: [] },
    { path: "", name: "中分類", pathName: "CommodityMid", value: "Y", children: [] },
    { path: "", name: "商品", pathName: "CommodityPage", value: "Y", children: [] },
    { path: "", name: "小分類", pathName: "CommoditySmall", value: "Y", children: [] },
    { path: "", name: "首頁", pathName: "Index", value: "Y", children: [] },
    { path: "", name: "登入", pathName: "Login", value: "Y", children: [] },
    {
      path: "",
      name: "會員資料",
      pathName: "MemberCenter",
      value: "Y",
      children: [
        { path: "", name: "基本資料", pathName: "MemberCenterBasicInfo", value: "Y", children: [] },
        { path: "", name: "修改密碼", pathName: "MemberCenterChangePassword", value: "Y", children: [] },
        { path: "", name: "訂單查詢", pathName: "MemberCenterOrderSearch", value: "Y", children: [] },
        { path: "", name: "退訂/退貨查詢", pathName: "MemberCenterOrderReturnSearch", value: "Y", children: [] },
        { path: "", name: "折扣碼", pathName: "MemberCenterDiscountCode", value: "Y", children: [] },
        { path: "", name: "紅利", pathName: "MemberCenterDividend", value: "Y", children: [] },
        { path: "", name: "奴幣", pathName: "MemberCenterPawCoin", value: "Y", children: [] },
        { path: "", name: "購物金", pathName: "MemberCenterShoppingPoints", value: "Y", children: [] },
        { path: "", name: "收藏清單", pathName: "MemberCenterFavoritesList", value: "Y", children: [] },
      ],
    },
    { path: "", name: "自訂頁面0", pathName: "CustomPage0", value: "Y", children: [] },
    { path: "", name: "自訂頁面1", pathName: "CustomPage1", value: "Y", children: [] },
    { path: "", name: "購物須知", pathName: "ShoppingGuide", value: "Y", children: [] },
    { path: "", name: "FAQ常見問題", pathName: "FAQPage", value: "Y", children: [] },
    { path: "", name: "隱私權條款", pathName: "TermPage", value: "Y", children: [] },
  ];

  return {
    TemplatePagesArr1,
    TemplatePagesArr2,
    TemplatePagesArr3,
  };
})();
